<template>
    <div class="contents grey lighten-3" :style="{height:rankData.desserts.length?'auto':'100vh'}">
    <v-container fill-height
                 fluid>
      <v-layout class="white px-4 pt-4"
                row
                wrap>
        <v-flex>
          <v-layout row
                    wrap>
            <v-flex lg12
                    md12
                    xs12>
              <v-card flat>
                <v-card-actions class="d-inline-flex pointer_title pa-0"
                                @click="rankData.isOpen=!rankData.isOpen">
                  <img src="../../assets/img/ranking/progress-ranking.png" alt="">&#8195;
                  <span class="title font-weight-bold ml-1">Conversion Progress Ranking（{{formatTime()}}）</span>
                  <v-icon style="cursor: pointer;"
                          left
                          large>
                    {{rankData.isOpen? 'arrow_drop_up':'arrow_drop_down'}}
                  </v-icon>
                </v-card-actions>
                <v-card-text v-show="rankData.isOpen"
                             class="elevation-4">
                    <p>1. The final ranking will be calculated on each month 1st , 16th.</p>
                    <p>2. Trial tutor can be qualified to participate in the ranking when trial tutor has 15 or more than   15 successfully conducted trial classes for last two cuts-off, and each cut-off should conduct 15 trial classes.</p>
                    <p>3. On the basis of conversion rate difference between two cuts-off, the ranking will be counted from highest rate to lowest rate, and the bonus will be rewarded by ranking place.</p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 mt-3>
                <v-card>
                    <v-layout class="white pt-2 text-xs-center"
                            row
                            wrap>
                        <v-flex xs4> 
                            <p class="mb-0 font-weight-bold grey--text">Current Conversion</p>
                            <h1 class="pb-4 pt-2 my-ranking">{{parseIntCon(rankAndRate.Conversion)}}%
                                <span class="arrow-count title" v-if="rankAndRate.IsConversionUp>0 || rankAndRate.IsConversionUp==0"><img class="arrow-up" src="../../assets/img/ranking/arrow-up.png" alt=""></span>
                                <span class="arrow-count title" v-else><img class="arrow-down" src="../../assets/img/ranking/arrow-down.png" alt=""></span>
                            </h1>
                            <p class="mb-1 grey--text">Last ： {{parseIntCon(rankAndRate.LastConversion)}}%</p>
                        </v-flex>
                        <v-flex xs4>
                            <p class="mb-0 font-weight-bold grey--text">Growth Rate</p>
                            <h1 class="pb-4 pt-2 my-ranking border-x">{{parseIntCon(rankAndRate.IsConversionUp)}}%</h1>
                        </v-flex>
                        <v-flex xs4>
                            
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex lg12
                    md12
                    xs12
                    class="mt-2">
              <v-card flat>
                <v-data-table :headers="rankData.headers"
                              :items="rankData.desserts"
                              hide-actions
                              :loading="loading"
                              no-data-text="No Data!"
                              class="elevation-2">
                  <template slot="items"
                            slot-scope="props">
                    <td class="text-xs-center" v-if="props.item.Ranking==1"><img width="40px" height="40px" src="../../assets/img/ranking/ranking-1.png" alt=""></td>
                    <td class="text-xs-center" v-else-if="props.item.Ranking==2"><img width="40px" height="40px" src="../../assets/img/ranking/ranking-2.png" alt=""></td>
                    <td class="text-xs-center" v-else-if="props.item.Ranking==3"><img width="40px" height="40px" src="../../assets/img/ranking/ranking-3.png" alt=""></td>
                    <td class="text-xs-center" v-else><div class="ranking-other my-0 mx-auto title"><span>{{props.item.Ranking | formatRank}}</span></div></td>
                    <td class="text-xs-center"><img width="51px" height="51px" style="border-radius: 50%" :src="props.item.PhotoUrl" alt=""></td>
                    <td class="text-xs-center">{{ props.item.TutorName.replace(/(\w{3})\w{3}(\w)/, '$1***$2') }}</td>
                    <td class="text-xs-center">{{ parseIntCon(props.item.Conversion) }}%</td>
                    <td class="text-xs-center">{{ parseIntCon(props.item.LastConversion) }}%</td>
                    <td class="text-xs-center">{{ parseIntCon(props.item.ConversionChange) }}%</td>
                    <td class="text-xs-center">{{ props.item.Bonus }}</td>
                  </template>
                </v-data-table>
                <template slot="no-data">
                  <v-btn color="primary">Reset</v-btn>
                </template>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { getConversionProgressLeaderboard,getTuTopTutorRank } from '@/api/tutordata'
import { formatDate } from '@/utils/date'
export default {
  name: 'rankData',
  data: () => ({
    loading: true,
    rankAndRate:{
      Conversion:0,
      LastConversion:0,
      IsConversionUp:0,
      Currency:''
    },
    rankData: {
      isOpen: false,
      loading: true,
      headers: [
        {
          text: 'Ranking',
          sortable: false,
          align: 'center',
          value: 'Ranking'
        },
        {
          text: 'Tutor Profile',
          sortable: false,
          align: 'center',
          value: 'PhotoUrl'
        },
        {
            text:'Name',
            sortable:false,
            align:'center',
            value:'TutorName'
        },
        {
          text: 'Current Conversion',
          sortable: false,
          align: 'center',
          value: 'Conversion'
        },
        {
          text: 'Last Conversion',
          sortable: false,
          align: 'center',
          value: 'LastConversion'
        },
        {
            text:'Growth Rate',
            sortable: false,
            align: 'center',
            value: 'ConversionChange'
        },
        {
            text:'Bonus',
            sortable:false,
            align:'center',
            value:'Bonus'
        }
      ],
      desserts: []
    }
  }),
  async mounted () {
    let resdata = await getTuTopTutorRank().then(res=>res.data);
    if(resdata.ErrorCode==0){
      this.rankAndRate = resdata.Body;
    }
    getConversionProgressLeaderboard().then(res=>{
      this.loading = false;
      if(res.data.ErrorCode === 0){
        this.rankData.desserts = res.data.Body;
        this.rankData.desserts.forEach((value,index)=>{
          if(this.rankAndRate.Currency=='PHP'){
            if(value.Ranking==1) value.Bonus = '5000PHP';
            else if(value.Ranking==2) value.Bonus = '4000PHP';
            else if(value.Ranking==3) value.Bonus = '3000PHP';
            else if(value.Ranking<7) value.Bonus = '2000PHP';
            else if(value.Ranking<11) value.Bonus = '1500PHP';
            else if(value.Ranking<21) value.Bonus = '1000PHP';
          }else if(this.rankAndRate.Currency=='USD'){
            if(value.Ranking==1) value.Bonus = '100USD';
            else if(value.Ranking==2) value.Bonus = '80USD';
            else if(value.Ranking==3) value.Bonus = '60USD';
            else if(value.Ranking<7) value.Bonus = '40USD';
            else if(value.Ranking<11) value.Bonus = '30USD';
            else if(value.Ranking<21) value.Bonus = '20USD';
          }
        })
      }
    })
  },
  methods: {
    parseIntCon(num){
      return (num*100).toFixed(2)
    },
    formatTime(){
      if(new Date().getDate()<16){
        // 16-月底
        var sixteen = new Date(new Date().getFullYear(), new Date().getMonth()-1, 16);
        var lastDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
        return formatDate(sixteen,'MM/dd/yyyy')+"—"+formatDate(lastDate,'MM/dd/yyyy');
      }else{
        // 1-15
        var first = new Date().getFullYear()+"/"+(new Date().getMonth()+1)+"/1";
        var fifteen = new Date().getFullYear()+"/"+(new Date().getMonth()+1)+"/15";
        return formatDate(first,'MM/dd/yyyy')+"—"+formatDate(fifteen,'MM/dd/yyyy');
      }
    }
  },
  filters:{
    formatRank(rank){
      return rank<10 ? "0"+rank : rank
    }
  }
}
</script>
<style scoped>
.border-x{
    border-left: 1px solid gray;
    border-right: 1px solid gray;
}
.my-ranking{
    position: relative;
}
.arrow-count{
    position: absolute;
    right: 20px;
}
.arrow-count>i{
    width: 24px
}
.ranking-other{
    position: relative;
    text-align: center;
    width: 40px;
    height: 40px;
    /* background-image: url(../../assets/img/ranking/ranking-other.png); */
    background-size: 100% 100%;
    color: #e2be98
}
.ranking-other>span{
    line-height: 40px;
}
.arrow-up{
  transform: rotate(-90deg);
}
.arrow-down{
  transform: rotate(90deg);
}
</style>